import React, { useMemo, useState } from "react";
import axios from "axios";
import { CheckCircle, Globe, ShieldCheck, Sparkles, BadgeCheck } from "lucide-react";
import "./Payments.css";

const Payments = ({ userId }) => {
  const [isProcessing, setIsProcessing] = useState(false);

  const handleCheckout = async () => {
    if (!userId) {
      alert("Error: User ID is missing. Please log in again.");
      return;
    }

    setIsProcessing(true);
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/api/payments/create-checkout-session`,
        { userId }
      );

      if (response?.data?.url) {
        window.location.href = response.data.url;
      } else {
        throw new Error("No checkout URL returned from server.");
      }
    } catch (error) {
      console.error("Checkout Error:", error);
      alert("Something went wrong initializing the payment. Please try again.");
      setIsProcessing(false);
    }
  };

  const premiumFeatures = useMemo(
    () => [
      "5 Premium International Job Applies",
      "Job selection assistance, screening & interview guidance",
      "Mock online assessment (complimentary)",
      "Actual assessment/test (complimentary)",
      "Comprehensive documentation support",
      "Visa processing assistance",
      "Pre-departure training & onboarding",
    ],
    []
  );

  return (
    <div className="payments-page">
      <div className="payments-shell">
        <div className="pricing-wrap">
          <div className="pricing-card">
            {/* LEFT PANEL */}
            <div className="card-left">
              <div className="left-head">
                <div className="icon-bubble">
                  <Globe size={26} />
                </div>
                <div>
                  <div className="plan-name">Global Premium Pass</div>
                  <div className="plan-desc">
                    A complete assisted journey — from job selection to visa support.
                  </div>
                </div>
              </div>

              <div className="left-badges">
                <div className="mini-badge">
                  <BadgeCheck size={16} />
                  Verified jobs & guidance
                </div>
                <div className="mini-badge">
                  <ShieldCheck size={16} />
                  Secure payments (Stripe)
                </div>
                <div className="mini-badge">
                  <Sparkles size={16} />
                  Priority support
                </div>
              </div>

              <div className="left-divider" />

              <div className="left-highlight">
                <div className="highlight-title">What you get</div>
                <ul className="highlight-list">
                  <li>✔ Apply to premium international roles</li>
                  <li>✔ Interview & assessment preparation</li>
                  <li>✔ Documentation + visa assistance</li>
                  <li>✔ Pre-departure onboarding support</li>
                </ul>
              </div>

              <div className="left-note">
                <ShieldCheck size={16} />
                Payments are processed securely. We do not store card details.
              </div>
            </div>

            {/* RIGHT PANEL */}
            <div className="card-right">
              <div className="price-box">
                <div className="price-line">
                  <span className="price">$135</span>
                  <span className="per">/ Package</span>
                </div>
                <div className="price-note">
                  *Auto-converts to your local currency at checkout
                </div>
              </div>

              <div className="features-box">
                <div className="features-title">PACKAGE INCLUDES</div>

                <div className="features-list">
                  {premiumFeatures.map((f, idx) => (
                    <div className="feature-row" key={idx}>
                      <CheckCircle className="feature-ic" size={20} />
                      <div className="feature-text">{f}</div>
                    </div>
                  ))}
                </div>
              </div>

              <button
                className={`cta ${isProcessing ? "loading" : ""}`}
                onClick={handleCheckout}
                disabled={isProcessing}
              >
                {isProcessing ? "Redirecting securely..." : "Upgrade Now"}
              </button>

              <div className="trust-row">
                <div className="trust-pill">
                  <ShieldCheck size={16} />
                  Guaranteed safe & secure checkout
                </div>
              </div>
            </div>
          </div>

          <div className="fineprint">
            Need help before upgrading? Contact support and we’ll guide you with job selection and eligibility.
          </div>
        </div>
      </div>
    </div>
  );
};

export default Payments;